let valuePropsElement = null;
let apiPollInterval = null;
let apiTimeout = null;

function initValueProps() {
  if (!window.testValuePropsCarts) return false;

  // Cache the element if not already cached
  if (!valuePropsElement) {
    valuePropsElement = document.querySelector('.value-props-section');
  }
  if (!valuePropsElement) return false;

  const host = document.getElementById('upCart');
  const container = host?.shadowRoot?.querySelector('.value-props-container-outer');
  
  if (container) {
    // Prevent redundant appends
    if (valuePropsElement.parentElement === container) {
      return true;
    }
    valuePropsElement.setAttribute('data-loaded', 'true');
    valuePropsElement.style.display = 'flex';
    container.appendChild(valuePropsElement); 
    return true;
  }

  return false;
}

function setupUpCartListeners() {
  const hasLoaded = typeof window.upcartSubscribeCartLoaded === 'function';
  const hasUpdated = typeof window.upcartSubscribeCartUpdated === 'function';
  const hasOpened = typeof window.upcartSubscribeCartOpened === 'function';

  // If the global API methods aren't ready yet, keep waiting
  if (!hasLoaded && !hasUpdated && !hasOpened) return false;

  // Clean up polling timers immediately once API is found
  clearInterval(apiPollInterval);
  clearTimeout(apiTimeout);

  const triggerInit = () => setTimeout(initValueProps, 50);

  if (hasLoaded) window.upcartSubscribeCartLoaded(triggerInit);
  if (hasUpdated) window.upcartSubscribeCartUpdated(triggerInit);
  if (hasOpened) window.upcartSubscribeCartOpened(triggerInit);

  // Run once initially
  initValueProps();
  return true;
}

function startLifecycle() {
  // 1. Try to initialize immediately if the API is ready
  if (setupUpCartListeners()) return;

  // 2. Fallback: Poll for the API if it's a third-party script loading asynchronously
  apiPollInterval = setInterval(() => {
    setupUpCartListeners();
  }, 100);

  // 3. Prevent infinite polling
  apiTimeout = setTimeout(() => {
    clearInterval(apiPollInterval);
    // Ultimate fallback: If events failed to load, try one last desperation append
    initValueProps(); 
  }, 10000);
}

// Kickstart the process
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startLifecycle);
} else {
  startLifecycle();
}